import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=9304e316"
import script from "./Menu.ts?vue&type=script&lang=ts&external"
export * from "./Menu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports